
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rent/success",
      function () {
        return require("private-next-pages/rent/success.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rent/success"])
      });
    }
  